// Import Hook modules
import groupEmailerConfirmDraftDelete from './confirm_draft_delete';
import groupEmailerIndicateCurrentDraftEditor from './indicate_current_draft_editor';
import groupEmailerResubscribe from './resubscribe';
import groupEmailerSendPreview from './send_preview';
import groupEmailerWysiwygEditor from './wysiwyg_editor';

export default {
  ...groupEmailerConfirmDraftDelete,
  ...groupEmailerIndicateCurrentDraftEditor,
  ...groupEmailerResubscribe,
  ...groupEmailerSendPreview,
  ...groupEmailerWysiwygEditor,
};
